module.exports = "../../product-store.JPG";